




























import { Vue, Prop, Component } from 'vue-property-decorator';
import { Colors } from 'vuetify/es5/util/colors';

@Component
export default class ButtonDropdown extends Vue {
  @Prop() buttonText?: string;

  @Prop() color?: Colors;

  @Prop() disabled?: boolean;

  @Prop() items?: any;

  click(type: any) {
    this.$emit('click', type);
  }
}
